export enum Scope {
  None = -1,
  One = 1,
  Two = 2,
  Three = 3,
}
